// Central hook for every lead-capturing form on the site (contact, brochure,
// catalogue, demo requests, etc). Call this from a form's submit handler —
// it never throws, and resolves true/false so callers can decide whether to
// show a success or error toast.
const ERP_LEAD_URL = "https://erp.springxe.com/api/method/common_customization.api.website_lead.capture_website_lead";

// source: short label identifying which form fired (e.g. "contact", "brochure-request")
export const postWebsiteLead = async (fields, source) => {
    const payload = {
        ...fields,
        source,
        page_url: typeof window !== "undefined" ? window.location.href : undefined,
    };

    try {
        const res = await fetch(ERP_LEAD_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        return res.ok;
    } catch {
        return false;
    }
};
